/* ==========================================================================
   LUNEXUS — Cart Drawer V3 · Clean Design · Toast statt Auto-Open
   ========================================================================== */
(function(){
  'use strict';

  var CUTOFF=11,TRANSIT=2,INJECTING=false;
  var TIERS=[{ab:2,pct:5},{ab:5,pct:10},{ab:10,pct:15}];
  var WT=['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'];
  var MO=['Jan.','Feb.','M\u00e4rz','Apr.','Mai','Juni','Juli','Aug.','Sep.','Okt.','Nov.','Dez.'];

  /* ── Datum-Helfer ──────────────────────────────────── */
  function ostern(y){var a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451);var mo=Math.floor((h+l-7*m+114)/31)-1,da=((h+l-7*m+114)%31)+1;return new Date(y,mo,da);}
  function dt(y,m,d){return new Date(y,m-1,d);}
  function sameDay(a,b){return a.toDateString()===b.toDateString();}
  function addDays(d,n){var r=new Date(d);r.setDate(r.getDate()+n);return r;}
  function fmtShort(d){return WT[d.getDay()].substring(0,2)+'. '+d.getDate()+'. '+MO[d.getMonth()];}
  function fmtLong(d){return WT[d.getDay()]+', '+d.getDate()+'. '+MO[d.getMonth()];}
  function getFt(y){var o=ostern(y);return[dt(y,1,1),addDays(o,-2),addDays(o,1),dt(y,5,1),addDays(o,39),addDays(o,50),dt(y,10,3),dt(y,12,25),dt(y,12,26)];}
  function istFrei(d,ft){if(d.getDay()===0)return true;for(var i=0;i<ft.length;i++){if(sameDay(d,ft[i]))return true;}return false;}
  function addWt(d,n,ft){var r=new Date(d);var c=0;while(c<n){r.setDate(r.getDate()+1);if(!istFrei(r,ft))c++;}return r;}
  function getShip(now,ft){var s=new Date(now);if(now.getHours()>=CUTOFF)s.setDate(s.getDate()+1);while(istFrei(s,ft))s.setDate(s.getDate()+1);return s;}

  function getAnlass(now){
    var y=now.getFullYear(),o=ostern(y),h=new Date(y,now.getMonth(),now.getDate());
    var a=[
      {n:'Ostern',ga:addDays(o,-14),gb:addDays(o,-5),t:'Rechtzeitig zu Ostern'},
      {n:'Weihnachten',ga:dt(y,12,1),gb:dt(y,12,21),t:'Vor Weihnachten'},
      {n:'Nikolaus',ga:dt(y,11,28),gb:dt(y,12,4),t:'Vor Nikolaus'},
      {n:'Valentinstag',ga:dt(y,2,6),gb:dt(y,2,12),t:'Zum Valentinstag'},
    ];
    for(var i=0;i<a.length;i++){if(h>=a[i].ga&&h<=a[i].gb)return a[i].t;}
    return null;
  }

  function calcShip(){
    var now=new Date(),cet=new Date(now.toLocaleString('en-US',{timeZone:'Europe/Berlin'}));
    var y=cet.getFullYear(),ft=getFt(y).concat(getFt(y+1));
    var ship=getShip(cet,ft),deliv=addWt(ship,TRANSIT,ft);
    var isToday=cet.getHours()<CUTOFF&&!istFrei(new Date(y,cet.getMonth(),cet.getDate()),ft);
    var cd='';
    if(isToday){var co=new Date(cet);co.setHours(CUTOFF,0,0,0);var diff=co-cet;var hh=Math.floor(diff/3600000);var mm=Math.floor((diff%3600000)/60000);cd=hh>0?hh+'h '+mm+'min':mm+'min';}
    return{deliv:deliv,ds:fmtShort(deliv),dl:fmtLong(deliv),isToday:isToday,cd:cd,anlass:getAnlass(cet)};
  }

  function getTier(n){
    var cur=null,nxt=null;
    for(var i=TIERS.length-1;i>=0;i--){if(n>=TIERS[i].ab){cur=TIERS[i];if(i<TIERS.length-1)nxt=TIERS[i+1];break;}}
    if(!cur)nxt=TIERS[0];
    return{cur:cur,nxt:nxt};
  }

  /* ── SVG Icons ─────────────────────────────────────── */
  var IC='<svg viewBox="0 0 24 24" fill="none" stroke-width="2" style="width:12px;height:12px"';
  function svgCheck(c){return IC+' stroke="'+c+'"><polyline points="20 6 9 17 4 12"/></svg>';}
  function svgClock(c){return IC+' stroke="'+c+'" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>';}
  var S_LOCK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="width:10px;height:10px"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>';
  var S_OK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="width:10px;height:10px"><path d="M9 12l2 2 4-4"/><circle cx="12" cy="12" r="10"/></svg>';
  var S_DONE='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="width:10px;height:10px"><path d="M20 6L9 17l-5-5"/></svg>';

  /* ── HTML Builder ──────────────────────────────────── */
  function buildInfoBar(cart,sd){
    var n=cart.item_count,t=getTier(n);
    /* Zeile 1: Versand + Lieferung + Anlass */
    var z1=svgCheck('#1a7a3a')+'<span class="lx-ci__txt"><span class="lx-ci__gr">Gratis Versand</span> &#183; Lieferung bis '+sd.dl;
    if(sd.anlass)z1+=' &#183; <span class="lx-ci__mu">'+sd.anlass+'</span>';
    z1+='</span>';
    /* Zeile 2: Rabatt */
    var z2='';
    if(t.cur&&t.nxt){
      z2=svgCheck('#1a7a3a')+'<span class="lx-ci__txt"><span class="lx-ci__gr">'+t.cur.pct+' % Rabatt aktiv</span> &#183; noch <span class="lx-ci__li">'+(t.nxt.ab-n)+'</span> bis '+t.nxt.pct+' %</span>';
    }else if(t.cur){
      z2=svgCheck('#1a7a3a')+'<span class="lx-ci__txt"><span class="lx-ci__gr">'+t.cur.pct+' % Rabatt aktiv</span> &#183; Maximum erreicht</span>';
    }else if(t.nxt){
      z2=svgClock('#914f9e')+'<span class="lx-ci__txt">Noch <span class="lx-ci__li">'+(t.nxt.ab-n)+'</span> Artikel bis '+t.nxt.pct+' % Rabatt</span>';
    }
    if(sd.isToday&&!sd.anlass){
      z1=svgCheck('#1a7a3a')+'<span class="lx-ci__txt"><span class="lx-ci__gr">Gratis Versand</span> &#183; Bestelle in '+sd.cd+' &#x2014; Lieferung bis '+sd.ds+'</span>';
    }
    return '<div class="lx-ci"><div class="lx-ci__row lx-ci__row--ship">'+z1+'</div>'+(z2?'<div class="lx-ci__row lx-ci__row--rabatt">'+z2+'</div>':'')+'</div>';
  }

  function buildFooter(cart){
    var total=(cart.total_price/100).toFixed(2).replace('.',',');
    var save='';
    if(cart.total_discount>0){
      var t=getTier(cart.item_count);
      var pctLabel=t.cur?t.cur.pct+' % Mengenrabatt':'Rabatt';
      save='<div class="lx-ft__save">Du sparst &#x20AC;'+(cart.total_discount/100).toFixed(2).replace('.',',')+' ('+pctLabel+')</div>';
    }
    return '<div class="lx-ft">'+save+
      '<button class="lx-ft__cta" type="submit" name="checkout" form="cart-form">Sicher zur Kasse &#183; &#x20AC;'+total+'</button>'+
      '<div class="lx-ft__trust"><span class="lx-ft__ti">'+S_LOCK+' SSL</span><span class="lx-ft__ti">'+S_OK+' 30 Tage R&#xFC;ckgabe</span><span class="lx-ft__ti">'+S_DONE+' Zertifikat</span></div>'+
      '<div class="lx-ft__pay"><span>PayPal</span><span>Klarna</span><span>VISA</span><span>MC</span><span>GPay</span><span>Apple</span></div>'+
    '</div>';
  }

  function buildDiscount(){
    return '<div class="lx-disc"><input type="text" placeholder="Gutscheincode" id="lx-disc-input"><button onclick="lxApplyDiscount()">Einl&#xF6;sen</button></div>';
  }

  function buildUpsell(p){
    var img=p.featured_image||'';
    var title=p.title.length>40?p.title.substring(0,37)+'...':p.title;
    var price=(parseInt(p.variants[0].price)/100).toFixed(2).replace('.',',');
    var vid=p.variants[0].id;
    return '<div class="lx-ups"><div class="lx-ups__l">Kunden kauften auch</div><div class="lx-ups__c">'+
      (img?'<img class="lx-ups__img" src="'+img+'&width=88" alt="" loading="lazy" width="44" height="44">':'<div class="lx-ups__img"></div>')+
      '<div class="lx-ups__inf"><div class="lx-ups__n">'+title+'</div><div class="lx-ups__p">&#x20AC;'+price+'</div></div>'+
      '<button class="lx-ups__btn" onclick="lxAddToCart('+vid+',this)">+ Hinzuf&#xFC;gen</button></div></div>';
  }

  function buildEmpty(){
    return '<div class="lx-empty">'+
      '<svg class="lx-empty__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>'+
      '<div class="lx-empty__h">Dein Warenkorb ist leer</div>'+
      '<div class="lx-empty__p">Entdecke unsere handverlesenen Devotionalien &#x2014; kirchlich gesegnet und mit Liebe verpackt.</div>'+
      '<a class="lx-empty__cta" href="/collections/all">Sortiment entdecken</a>'+
      '<div class="lx-empty__feats">'+
        '<div class="lx-empty__f"><div class="lx-empty__fi lx-empty__fi--g"><svg viewBox="0 0 24 24" fill="none" stroke="#1a5c30" stroke-width="2" style="width:12px;height:12px"><polyline points="20 6 9 17 4 12"/></svg></div><div><div class="lx-empty__ft">Gratis Versand DE</div><div class="lx-empty__fs">Kostenloser Versand in Deutschland</div></div></div>'+
        '<div class="lx-empty__f"><div class="lx-empty__fi lx-empty__fi--l"><svg viewBox="0 0 24 24" fill="none" stroke="#6b2a7a" stroke-width="2" style="width:12px;height:12px"><line x1="12" y1="3" x2="12" y2="21"/><line x1="5" y1="9" x2="19" y2="9"/></svg></div><div><div class="lx-empty__ft">Kirchlich gesegnet</div><div class="lx-empty__fs">Inkl. Samtbeutel &amp; Zertifikat</div></div></div>'+
        '<div class="lx-empty__f"><div class="lx-empty__fi lx-empty__fi--w"><svg viewBox="0 0 24 24" fill="none" stroke="#7a4a00" stroke-width="1.8" style="width:12px;height:12px"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/></svg></div><div><div class="lx-empty__ft">30 Tage R&#xFC;ckgaberecht</div><div class="lx-empty__fs">Kein Risiko</div></div></div>'+
      '</div></div>';
  }

  /* ── Add to Cart (AJAX, Drawer bleibt offen) ───────── */
  window.lxAddToCart=function(vid,btn){
    if(btn){btn.textContent='...';btn.disabled=true;}
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:vid,quantity:1}]})})
    .then(function(r){return r.json();}).then(function(){
      var sid=document.querySelector('cart-items-component');
      if(!sid){location.reload();return;}
      var secId=sid.dataset.sectionId;
      if(!secId){location.reload();return;}
      return fetch('/?sections='+secId).then(function(r){return r.json();}).then(function(secs){
        var html=secs[secId];if(!html)return;
        INJECTING=true;if(observer)observer.disconnect();
        var tmp=document.createElement('div');tmp.innerHTML=html;
        var nc=tmp.querySelector('cart-items-component');
        if(nc)sid.innerHTML=nc.innerHTML;
        var dlg=document.querySelector('.cart-drawer__dialog');
        if(dlg)dlg.classList.remove('cart-drawer--empty');
        var nb=tmp.querySelector('.cart-bubble');var ob=document.querySelector('.cart-drawer__heading .cart-bubble');
        if(nb&&ob)ob.replaceWith(nb);
        setTimeout(function(){INJECTING=false;enhance();startObs();},300);
      });
    }).catch(function(){location.reload();});
  };

  /* ── Gutschein anwenden ────────────────────────────── */
  window.lxApplyDiscount=function(){
    var inp=document.getElementById('lx-disc-input');
    if(!inp||!inp.value.trim())return;
    var code=inp.value.trim();
    fetch('/discount/'+encodeURIComponent(code)).then(function(){location.reload();}).catch(function(){location.reload();});
  };

  /* ── Upsell laden ──────────────────────────────────── */
  function loadUpsell(pid,cb){
    fetch('/recommendations/products.json?product_id='+pid+'&limit=4&intent=related')
    .then(function(r){return r.json();}).then(function(d){
      var ps=d.products||[];
      fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
        var ids=cart.items.map(function(i){return i.product_id;});
        for(var i=0;i<ps.length;i++){if(ids.indexOf(ps[i].id)===-1){cb(ps[i]);return;}}
        cb(null);
      });
    }).catch(function(){cb(null);});
  }

  /* ── Toast ─────────────────────────────────────────── */
  function showToast(msg){
    var old=document.querySelector('.lx-toast');if(old)old.remove();
    var t=document.createElement('div');
    t.className='lx-toast';
    t.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="#1a7a3a" stroke-width="2" style="width:18px;height:18px"><path d="M9 12l2 2 4-4"/><circle cx="12" cy="12" r="10"/></svg>'+
      '<span>'+msg+'</span>'+
      '<span class="lx-toast__link" onclick="document.querySelector(\'cart-drawer-component\')?.open?.();this.closest(\'.lx-toast\').classList.remove(\'lx-toast--visible\')">Zum Warenkorb &#x203A;</span>';
    document.body.appendChild(t);
    requestAnimationFrame(function(){requestAnimationFrame(function(){t.classList.add('lx-toast--visible');});});
    setTimeout(function(){t.classList.remove('lx-toast--visible');setTimeout(function(){t.remove();},400);},4000);
  }

  /* ── Haupt-Enhancement ─────────────────────────────── */
  function enhance(){
    var dlg=document.querySelector('.cart-drawer__dialog');
    if(!dlg||dlg.querySelector('.lx-ci')||dlg.querySelector('.lx-empty'))return;

    if(dlg.classList.contains('cart-drawer--empty')){
      var cnt=dlg.querySelector('.cart-drawer__content');
      if(!cnt)return;
      /* Horizon Empty-Elemente verstecken */
      var h=cnt.querySelector('.cart-drawer__heading--empty');if(h)h.style.display='none';
      var iw=cnt.querySelector('.cart-drawer__items');
      if(iw){iw.querySelectorAll('p').forEach(function(p){p.style.display='none';});var b=iw.querySelector('.cart-items__empty-button');if(b)b.style.display='none';}
      (iw||cnt).insertAdjacentHTML('afterbegin',buildEmpty());
      return;
    }

    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      if(!cart||dlg.querySelector('.lx-ci'))return;
      var sd=calcShip();

      /* 1. Info-Bar nach Header */
      var content=dlg.querySelector('.cart-drawer__content');
      if(!content)return;
      content.insertAdjacentHTML('afterbegin',buildInfoBar(cart,sd));

      /* 2. Artikel: Auf Lager + Lieferung + "je" vor Stueckpreis */
      dlg.querySelectorAll('tr[role="row"]').forEach(function(row){
        if(row.querySelector('th')||row.querySelector('.lx-cart-item-extras'))return;
        var cells=row.querySelectorAll('td');if(cells.length<2)return;
        var info=cells[1],el=info.querySelector('a')||info.querySelector('div');
        if(!el)return;
        var ex=document.createElement('div');ex.className='lx-cart-item-extras';
        ex.innerHTML='<div class="lx-cis">Auf Lager</div><div class="lx-cid">Lieferung bis '+sd.ds+'</div>';
        el.parentNode.insertBefore(ex,el.nextSibling);
        /* "je" vor den Stueckpreis setzen */
        var priceDivs=info.querySelectorAll('div');
        priceDivs.forEach(function(d){
          if(d.classList.contains('lx-cart-item-extras'))return;
          var spans=d.querySelectorAll('span:not(.visually-hidden)');
          spans.forEach(function(s){
            var txt=s.textContent.trim();
            if(txt.match(/^[\u20AC\$][\d,.]+$/)&&!s.dataset.lxJe){
              s.dataset.lxJe='1';
              s.textContent='je '+txt;
            }
          });
        });
      });

      /* 3. Sticky Footer: Gutschein + Upsell + CTA ─────── */
      if(!dlg.querySelector('.lx-sticky-footer')){
        var stickyHtml='<div class="lx-sticky-footer">';
        stickyHtml+=buildDiscount();
        stickyHtml+='<div id="lx-ups-slot"></div>';
        stickyHtml+=buildFooter(cart);
        stickyHtml+='</div>';
        /* Direkt an cart-drawer__content anhaengen (ist flex parent) */
        content.insertAdjacentHTML('beforeend',stickyHtml);
      }

      /* Upsell async laden */
      if(cart.items.length>0){
        loadUpsell(cart.items[0].product_id,function(p){
          if(!p)return;
          var slot=dlg.querySelector('#lx-ups-slot');
          if(slot&&!slot.innerHTML)slot.innerHTML=buildUpsell(p);
        });
      }
    });
  }

  /* ── Cart Page Enhancement ─────────────────────────── */
  function enhancePage(){
    var pg=document.querySelector('.cart-page');
    if(!pg)return;

    /* Leerer Warenkorb */
    if(pg.classList.contains('cart-page--empty')){
      if(pg.querySelector('.lx-cp-empty'))return;
      var itemsArea=pg.querySelector('.cart-page__items');
      if(!itemsArea)return;
      /* Horizon Empty-Elemente verstecken */
      var loginP=itemsArea.querySelector('p');
      if(loginP)loginP.style.display='none';
      var contBtn=itemsArea.querySelector('.cart-items__empty-button');
      if(contBtn)contBtn.style.display='none';
      /* Unseren Empty State einfuegen */
      itemsArea.insertAdjacentHTML('afterbegin',
        '<div class="lx-cp-empty">'+
          '<svg class="lx-cp-empty__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>'+
          '<div class="lx-cp-empty__h">Dein Warenkorb ist leer</div>'+
          '<div class="lx-cp-empty__p">Entdecke unsere handverlesenen Devotionalien \u2014 kirchlich gesegnet, mit Samtbeutel &amp; Zertifikat und kostenlosem Versand.</div>'+
          '<a class="lx-cp-empty__cta" href="/collections/all">Sortiment entdecken</a>'+
          '<div class="lx-cp-empty__feats">'+
            '<div class="lx-cp-empty__f"><div class="lx-cp-empty__fi lx-cp-empty__fi--g"><svg viewBox="0 0 24 24" fill="none" stroke="#1a5c30" stroke-width="2" style="width:16px;height:16px"><polyline points="20 6 9 17 4 12"/></svg></div><div class="lx-cp-empty__ft">Gratis Versand</div><div class="lx-cp-empty__fs">Innerhalb Deutschlands</div></div>'+
            '<div class="lx-cp-empty__f"><div class="lx-cp-empty__fi lx-cp-empty__fi--l"><svg viewBox="0 0 24 24" fill="none" stroke="#6b2a7a" stroke-width="2" style="width:16px;height:16px"><line x1="12" y1="3" x2="12" y2="21"/><line x1="5" y1="9" x2="19" y2="9"/></svg></div><div class="lx-cp-empty__ft">Kirchlich gesegnet</div><div class="lx-cp-empty__fs">Mit Zertifikat</div></div>'+
            '<div class="lx-cp-empty__f"><div class="lx-cp-empty__fi lx-cp-empty__fi--w"><svg viewBox="0 0 24 24" fill="none" stroke="#7a4a00" stroke-width="1.8" style="width:16px;height:16px"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/></svg></div><div class="lx-cp-empty__ft">30 Tage Recht</div><div class="lx-cp-empty__fs">Einfache R\u00FCckgabe</div></div>'+
          '</div>'+
        '</div>'
      );
      return;
    }

    /* Schon enhanced? */
    if(pg.querySelector('.lx-cp-info'))return;

    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      if(!cart||cart.item_count===0||pg.querySelector('.lx-cp-info'))return;
      var sd=calcShip();
      var t=getTier(cart.item_count);

      /* 1. Info-Bar + "Weiter einkaufen" innerhalb cart-page__items */
      var itemsBlock=pg.querySelector('.cart-page__items');
      if(itemsBlock){
        itemsBlock.insertAdjacentHTML('afterbegin',
          '<a href="/collections/all" class="lx-cp-weiter-top">&larr; Weiter einkaufen</a>'+
          '<div class="lx-cp-info">'+buildInfoBar(cart,sd)+'</div>'
        );
      }

      /* 2. Auf Lager + je-Preis pro Artikel */
      pg.querySelectorAll('tr[role="row"]').forEach(function(row){
        if(row.querySelector('th')||row.querySelector('.lx-cart-item-extras'))return;
        var cells=row.querySelectorAll('td');if(cells.length<2)return;
        var info=cells[1],el=info.querySelector('a')||info.querySelector('div');
        if(!el)return;
        var ex=document.createElement('div');ex.className='lx-cart-item-extras';
        ex.innerHTML='<div class="lx-cis">Auf Lager</div><div class="lx-cid">Lieferung bis '+sd.ds+'</div>';
        el.parentNode.insertBefore(ex,el.nextSibling);
        var priceDivs=info.querySelectorAll('div');
        priceDivs.forEach(function(d){
          if(d.classList.contains('lx-cart-item-extras'))return;
          d.querySelectorAll('span:not(.visually-hidden)').forEach(function(s){
            var txt=s.textContent.trim();
            if(txt.match(/^[\u20AC\$][\d,.]+$/)&&!s.dataset.lxJe){s.dataset.lxJe='1';s.textContent='je '+txt;}
          });
        });
      });

      /* 3. Checkout-Button via ID (sicherster Selektor) */
      var checkBtn=document.getElementById('checkout');
      if(checkBtn){
        var total=(cart.total_price/100).toFixed(2).replace('.',',');
        checkBtn.textContent='Sicher zur Kasse \u00B7 \u20AC'+total;
      }

      /* 4. Sidebar: Du sparst + Trust + Payment */
      var summary=pg.querySelector('.cart-page__summary');
      if(summary&&!summary.querySelector('.lx-cp-trust')){
        /* "Geschaetzter Gesamtbetrag" → "Gesamt" */
        var totalLabel=summary.querySelector('.cart__total-label');
        if(totalLabel)totalLabel.textContent='Gesamt';

        /* Versand-Info in Summary einfuegen */
        var totalContainer=summary.querySelector('.cart__total-container');
        if(totalContainer&&!summary.querySelector('.lx-cp-ship')){
          totalContainer.insertAdjacentHTML('afterend','<div class="lx-cp-ship"><span style="color:#1a7a3a;font-weight:500;font-size:12px">Gratis Versand</span> <span style="font-size:11px;color:#999">&#183; Lieferung bis '+sd.dl+'</span></div>');
        }

        /* Du sparst */
        var ctas=summary.querySelector('.cart__ctas');
        if(ctas&&cart.total_discount>0){
          var pctLabel=t.cur?t.cur.pct+' % Mengenrabatt':'Rabatt';
          ctas.insertAdjacentHTML('beforebegin','<div class="lx-cp-save">Du sparst \u20AC'+(cart.total_discount/100).toFixed(2).replace('.',',')+' ('+pctLabel+')</div>');
        }

        /* Trust + Payment */
        if(ctas){
          ctas.insertAdjacentHTML('afterend',
            '<div class="lx-cp-trust"><div class="lx-cp-ti">'+S_LOCK+' SSL-verschl\u00FCsselt</div><div class="lx-cp-ti">'+S_OK+' 30 Tage R\u00FCckgabe</div><div class="lx-cp-ti">'+S_DONE+' Samtbeutel &amp; Zertifikat</div></div>'+
            '<div class="lx-cp-pay"><span>PayPal</span><span>Klarna</span><span>VISA</span><span>MC</span><span>GPay</span><span>Apple</span></div>'
          );
        }

        /* Gutschein offen */
        var discDet=summary.querySelector('details.discount-details');
        if(discDet)discDet.setAttribute('open','');
      }

      /* 5. Headings uebersetzen */
      document.querySelectorAll('h3,h4').forEach(function(h){
        if(h.textContent.trim()==='You may also like')h.textContent='Das k\u00F6nnte dir auch gefallen';
      });
      document.querySelectorAll('a,button').forEach(function(a){
        if(a.textContent.trim()==='View all')a.textContent='Alle ansehen';
      });
    });
  }

  /* ── Observer ──────────────────────────────────────── */
  var observer=null,debounce=null;
  function onMut(){
    if(INJECTING)return;
    clearTimeout(debounce);
    debounce=setTimeout(function(){
      INJECTING=true;if(observer)observer.disconnect();
      try{enhance();enhancePage();}catch(e){}
      setTimeout(function(){INJECTING=false;startObs();},500);
    },250);
  }
  function startObs(){
    if(observer)observer.disconnect();
    observer=new MutationObserver(onMut);
    [document.querySelector('.cart-drawer__inner'),document.querySelector('cart-items-component')].forEach(function(t){if(t)observer.observe(t,{childList:true,subtree:true});});
  }

  /* ── Auto-Open deaktivieren, Toast stattdessen ─────── */
  function disableAutoOpen(){
    var comp=document.querySelector('cart-drawer-component');
    if(comp&&comp.hasAttribute('auto-open')){
      comp.removeAttribute('auto-open');
    }
  }

  /* ── Init ──────────────────────────────────────────── */
  function init(){
    disableAutoOpen();
    enhance();
    enhancePage();
    startObs();
    /* Cart Page: Retries weil Horizon Blocks asynchron laden */
    if(document.querySelector('.cart-page')){
      setTimeout(enhancePage,500);
      setTimeout(enhancePage,1000);
      setTimeout(enhancePage,2000);
    }
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}
  else{init();}

  /* Cart-Icon Klick: enhance nach Verzoegerung */
  document.addEventListener('click',function(e){
    if(e.target.closest('cart-drawer-component button')||e.target.closest('.cart-icon')){
      setTimeout(function(){INJECTING=false;enhance();},400);
      setTimeout(function(){INJECTING=false;enhance();},800);
    }
  });

  /* Toast bei Add-to-Cart Event */
  var toastEvents=['cart:add','theme:cart:add'];
  toastEvents.forEach(function(evt){
    document.addEventListener(evt,function(){
      showToast('Produkt erfolgreich hinzugef\u00FCgt');
      /* Cart-Bubble im Header updaten */
      setTimeout(function(){
        fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
          var bubbles=document.querySelectorAll('.cart-bubble__text-count');
          bubbles.forEach(function(b){b.textContent=cart.item_count;});
        });
      },300);
    });
  });
  /* Fallback: globalen Fetch intercepten fuer Add-to-Cart */
  var origFetch=window.fetch;
  window.fetch=function(){
    var args=arguments;
    var url=typeof args[0]==='string'?args[0]:(args[0]&&args[0].url?args[0].url:'');
    if(url.indexOf('/cart/add')!==-1&&url.indexOf('section')!==-1===false){
      return origFetch.apply(this,args).then(function(resp){
        var clone=resp.clone();
        clone.json().then(function(data){
          if(data&&(data.items||data.id)){
            setTimeout(function(){showToast('Produkt erfolgreich hinzugef\u00FCgt');},100);
          }
        }).catch(function(){});
        return resp;
      });
    }
    return origFetch.apply(this,args);
  };
})();
